__turbopack_context__.v({
  "CategoryList": "MenuBar-module__l7rc7a__CategoryList",
  "DrawerMenu": "MenuBar-module__l7rc7a__DrawerMenu",
  "MenuBar": "MenuBar-module__l7rc7a__MenuBar",
  "active": "MenuBar-module__l7rc7a__active",
  "backButton": "MenuBar-module__l7rc7a__backButton",
  "base": "MenuBar-module__l7rc7a__base",
  "body": "MenuBar-module__l7rc7a__body",
  "bodyMain": "MenuBar-module__l7rc7a__bodyMain",
  "bodyTop": "MenuBar-module__l7rc7a__bodyTop",
  "brandItem": "MenuBar-module__l7rc7a__brandItem",
  "brandList": "MenuBar-module__l7rc7a__brandList",
  "buttons": "MenuBar-module__l7rc7a__buttons",
  "categoryLevel": "MenuBar-module__l7rc7a__categoryLevel",
  "categoryList": "MenuBar-module__l7rc7a__categoryList",
  "categoryLists": "MenuBar-module__l7rc7a__categoryLists",
  "close": "MenuBar-module__l7rc7a__close",
  "closeButton": "MenuBar-module__l7rc7a__closeButton",
  "container": "MenuBar-module__l7rc7a__container",
  "contents": "MenuBar-module__l7rc7a__contents",
  "fadeIn": "MenuBar-module__l7rc7a__fadeIn",
  "full": "MenuBar-module__l7rc7a__full",
  "icon": "MenuBar-module__l7rc7a__icon",
  "item": "MenuBar-module__l7rc7a__item",
  "link": "MenuBar-module__l7rc7a__link",
  "mobileSubmenuPanel": "MenuBar-module__l7rc7a__mobileSubmenuPanel",
  "offerBtn": "MenuBar-module__l7rc7a__offerBtn",
  "prev": "MenuBar-module__l7rc7a__prev",
  "slideIn": "MenuBar-module__l7rc7a__slideIn",
  "slideInLeft": "MenuBar-module__l7rc7a__slideInLeft",
  "slideOut": "MenuBar-module__l7rc7a__slideOut",
  "slideOutLeft": "MenuBar-module__l7rc7a__slideOutLeft",
  "submenuLeft": "MenuBar-module__l7rc7a__submenuLeft",
  "submenuPanel": "MenuBar-module__l7rc7a__submenuPanel",
  "submenuRight": "MenuBar-module__l7rc7a__submenuRight",
  "title": "MenuBar-module__l7rc7a__title",
  "top": "MenuBar-module__l7rc7a__top",
});
